import React from 'react';
import { CardCvcElement } from '@stripe/react-stripe-js';
import { IPayments } from 'interfaces/payment';

const CardCVV: React.SFC<IPayments.ICardElementProp> = props => {
  return (
    <div className='form-group ml-auto cvv'>
      <label>CVV</label>
      <div className='form-control' id='card-cvv-element'>
        <CardCvcElement
          options={props.styles}
        />
      </div>
    </div>
  );
};

export default CardCVV;
